import * as actionType from "../constants";
export const BoardMessageDeactivate = () => async (dispatch) => {
  dispatch({ type: actionType.BOARD_MESSAGE_DEACTIVATE });
};
